export const SubmitOnEnter = {
  mounted() {
    this.el.addEventListener('keydown', (e) => {
      if (e.key == 'Enter' && !e.shiftKey) {
        e.target.form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        e.target.value = null;

        e.preventDefault();
      }
    });
  },
};
